<template>
  <class-wrap
    :class-data="classData"
    :unlock-data="unlockData"
    :content-info="contentInfo"
  >
    <template slot="ico">&#xe74d;</template>
    视频<span class="i" v-if="content.duration">&nbsp;|&nbsp;{{content.duration}}</span>
  </class-wrap>
</template>
<script>
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import ClassWrap from './class-wrap.vue'
import ClassMixins from '@/modules/course/components/class-list/class-mixins'

  @Component({
    components: {
      ClassWrap
    }
  })
export default class VideoClassItem extends Mixins(ClassMixins) {
}
</script>
<style lang="scss" scoped rel="stylesheet/scss">
</style>
